import React from 'react'
import Img from 'gatsby-image'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'
import { Link } from 'components/Link'
import { Container } from 'components/Grid'

const OffsetBanner = styled.div`
  width: 100%;
  background: #efefef;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding: 50px 40px 40px 40px;
  text-align: center;

  div {
    max-width: 60%;
    display: block;
    margin: 0 auto;

    @media (max-width: 640px) {
      max-width: 90%;
    }
  }
`

const StyledLink = styled(Link)`
  color: #000;
  text-decoration: none;
`

const HighlightedPostSection = styled.div`
  padding: 0;
  max-height: 420px;

  @media (max-width: 640px) {
    max-height: none;
  }
`

const HighlightedPostBackground = styled.div`
  background: rgb(235, 217, 208);
  width: calc(100% + 40px);
  margin-left: -20px;
  padding: 0 20px;
  height: 240px;
  position: relative;
  top: -280px;
  z-index: 2;

  @media (max-width: 640px) {
    display: none;
  }
`

const HighlightedPost = styled.div`
  display: flex;
  z-index: 3;

  @media (max-width: 640px) {
    display: block;
  }
`

const HighlightedPostImage = styled.div`
  flex: 1;
  z-index: 3;

  a {
    color: #000;
    text-decoration: none;
  }

  img {
    border: 5px solid white;
    border-radius: 4px;
  }
`

const HighlightedPostTitle = styled.div`
  flex: 2;
  padding: 70px;
  z-index: 3;

  h1 {
    font-size: 50px;
    font-family: 'Amatic SC', sans-serif !important;
    margin-bottom: 20px;
    max-width: 50%;

    @media (max-width: 640px) {
      max-width: none;
    }
  }

  a {
    color: #000;
    text-decoration: none;
  }
`

const ReadMoreButton = styled.div`
  background: #000;
  text-transform: uppercase;
  color: #fff;
  padding: 6px 20px;
  text-align: center;
  display: inline-block;
  font-weight: bold;
  font-size: 12px;
`

const RecentPostsSection = styled.div`
  background: #efefef;
  text-align: center;
  width: calc(100% + 40px);
  margin-left: -20px;
  padding: 60px 20px;
`

const RecentPosts = styled.div`
  display: flex;

  @media (max-width: 640px) {
    display: block;
  }
`

const RecentPostWrapper = styled.div`
  flex: 1;
  padding-right: 20px;
  text-align: center;

  a {
    color: #333;
    text-decoration: none;
  }
`

const RecentPost = styled.img`
  object-fit: contain;
  width: 260px;
  height: 260px;
  margin-bottom: 20px;
`

const AboutSection = styled.div`
  text-align: center;
  padding: 60px 0;

  > a > div {
    max-width: 60%;
    display: block;
    margin: 0 auto;

    @media (max-width: 640px) {
      max-width: 90%;
    }
  }
`

const QuoteSection = styled.div`
  text-align: center;
  padding: 60px 0;

  div {
    max-width: 60%;
    display: block;
    margin: 0 auto;

    @media (max-width: 640px) {
      max-width: 90%;
    }
  }
`

const InstagramSection = styled.div`
  text-align: center;
  padding: 60px 0;
`

const IGImages = styled.div`
  display: flex;
`

const IGImageWrapper = styled.div`
  flex: 1;
  padding-right: 20px;
`

const IGImage = styled.img`
  object-fit: contain;
  width: 140px;
  height: 140px;
`

export function IndexPage({ data }) {
  return (
    <Layout fullWidth>
      <SEO title="Home" />

      <HighlightedPostSection>
        {data &&
          data.allPrismicBlogPost &&
          data.allPrismicBlogPost.edges &&
          data.allPrismicBlogPost.edges[0] && (
            <Container maxWidth={'1040px'}>
              <HighlightedPost>
                <HighlightedPostImage>
                  <Link
                    to={'/blog/' + data.allPrismicBlogPost.edges[0].node.uid}
                  >
                    <img
                      src={
                        data.allPrismicBlogPost.edges[0].node.data.banner_image
                          .localFile.url
                      }
                      alt={
                        data.allPrismicBlogPost.edges[0].node.data.title.text
                      }
                    />
                  </Link>
                </HighlightedPostImage>
                <HighlightedPostTitle>
                  <Link
                    to={'/blog/' + data.allPrismicBlogPost.edges[0].node.uid}
                  >
                    <h1>
                      {data.allPrismicBlogPost.edges[0].node.data.title.text}
                    </h1>
                    <ReadMoreButton>Lees meer</ReadMoreButton>
                  </Link>
                </HighlightedPostTitle>
              </HighlightedPost>
            </Container>
          )}

        <HighlightedPostBackground />
      </HighlightedPostSection>

      <RecentPostsSection>
        <Container maxWidth={'1040px'}>
          <h2>Laatste blogs</h2>

          <RecentPosts>
            {data &&
              data.allPrismicBlogPost &&
              data.allPrismicBlogPost.edges &&
              data.allPrismicBlogPost.edges.slice(1).map(edge => (
                <RecentPostWrapper>
                  <Link to={'/blog/' + edge.node.uid}>
                    <RecentPost
                      src={edge.node.data.banner_image.localFile.url}
                      alt={edge.node.data.title.text}
                    />
                    <h3>{edge.node.data.title.text}</h3>
                  </Link>
                </RecentPostWrapper>
              ))}
          </RecentPosts>
        </Container>
      </RecentPostsSection>

      <AboutSection>
        <Link to={'/about/'}>
          <Img fluid={data.aboutImage.childImageSharp.fluid} />
        </Link>
      </AboutSection>

      <StyledLink to="/shop">
        <OffsetBanner>
          <Img fluid={data.filterImage.childImageSharp.fluid} />
        </OffsetBanner>
      </StyledLink>

      <QuoteSection>
        <Link to={'/positives/'}>
          <Img fluid={data.positivesImage.childImageSharp.fluid} />
        </Link>
      </QuoteSection>

      <InstagramSection>
        <Container maxWidth={'1040px'}>
          <h2>Volg ons op instagram @gutsy.fashion</h2>
          <IGImages>
            {data &&
              data.allInstaNode &&
              data.allInstaNode.edges.map(edge => (
                <IGImageWrapper>
                  <a href={'https://www.instagram.com/p/' + edge.node.id} target="_blank">
                    <IGImage src={edge.node.localFile.url} alt="Instagram foto" />
                  </a>
                </IGImageWrapper>
              ))}
          </IGImages>
        </Container>
      </InstagramSection>
    </Layout>
  )
}

export const query = graphql`
  query index {
    allPrismicBlogPost(
      sort: { fields: last_publication_date, order: DESC }
      limit: 4
    ) {
      edges {
        node {
          id
          uid
          data {
            title {
              html
              text
            }
            content {
              html
              text
            }
            banner_image {
              localFile {
                url
              }
            }
          }
        }
      }
    }

    aboutImage: file(relativePath: { eq: "about-image.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    filterImage: file(relativePath: { eq: "filter-image.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    positivesImage: file(relativePath: { eq: "positives-image.png" }) {
      childImageSharp {
        fluid(maxWidth: 1200) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    allInstaNode(limit: 6) {
      edges {
        node {
          id
          localFile {
            url
          }
        }
      }
    }
  }
`

export default IndexPage
